class Equalheights {
	constructor(data) {
		this.$item = $(data.each);
		this.array  = data.array;

		if(this.$item.length) {
			this.events();
		}
	}

	events() {
		const that = this;

	    this.resizeHeight(that.$item);

	    $(window).bind('resize', function () {
	      	that.resizeHeight(that.$item);
	    });

	    this.resizeMetadata();
	}

	resizeHeight(els) {
      	els.height('initial');
      	let maxH = els.eq(0).height();
		
		els.each(function() {
			maxH = ($(this).height() > maxH) ? $(this).height() : maxH;
		});

		els.height(maxH);
	}

	resizeMetadata() {
		$('.metadata dd').each(function() {
			var $dd = $(this),
				$dt = $dd.prev();

			if ($dt.height() > $dd.height()) {
				$dd.height($dt.height() + 'px');
			} else {
				$dt.height($dd.height() + 'px');
			}
		});
	}
}

export default {
	new(data) {
		new Equalheights(data);
	}
}


// WEBPACK FOOTER //
// ./src/js/modules/equalHeights.js